export const IMAGES = {
  heroRailway: "https://static.prod-images.emergentagent.com/jobs/8f915d65-2358-4023-8724-a892d400698b/images/f96bf0c786352b8a6414c195598291cd00d3284e53d18e2864f840d32e15b6fd.jpeg",
  digitalScreens: "https://static.prod-images.emergentagent.com/jobs/8f915d65-2358-4023-8724-a892d400698b/images/74097bf839f709f7bb3132e3275801822bd843208bb8d2919d4d25ec32f59c45.jpeg",
  outdoorHoarding: "https://static.prod-images.emergentagent.com/jobs/8f915d65-2358-4023-8724-a892d400698b/images/6f9559b28fb016a37f52d7328a5000d887928c2bfd5fea867b274496f4f070bd.jpeg",
  transitMedia: "https://static.prod-images.emergentagent.com/jobs/8f915d65-2358-4023-8724-a892d400698b/images/90692dafc45143a2d6ee906fc6566e2e2c2ce369b1e15407e8e08caac5175675.jpeg",
  coverageMap: "https://static.prod-images.emergentagent.com/jobs/8f915d65-2358-4023-8724-a892d400698b/images/4ade967bde7dbdd90596636e437f18a9e89b2e4a1d95d1aaa4fb9843de5c84ca.jpeg",
  logo: "/logo.png",
};

export const SERVICES = [
  {
    id: "railway",
    no: "01",
    title: "Railway Station Advertising",
    desc: "Promote your business inside major railway stations across India through strategically positioned display locations that reach thousands of commuters every day.",
    image: IMAGES.heroRailway,
  },
  {
    id: "digital",
    no: "02",
    title: "Digital Display Screens",
    desc: "Deliver dynamic and engaging advertisements using high-definition digital screens installed in premium public locations.",
    image: IMAGES.digitalScreens,
  },
  {
    id: "hoardings",
    no: "03",
    title: "Outdoor Hoardings",
    desc: "Increase your brand visibility through large-format outdoor advertising in strategic commercial and high-traffic areas.",
    image: IMAGES.outdoorHoarding,
  },
  {
    id: "transit",
    no: "04",
    title: "Transit Advertising",
    desc: "Reach audiences on the move through innovative transit advertising opportunities across transportation hubs.",
    image: IMAGES.transitMedia,
  },
  {
    id: "campaigns",
    no: "05",
    title: "Brand Promotion Campaigns",
    desc: "From single-location campaigns to multi-city branding initiatives, we help businesses execute effective outdoor advertising strategies.",
    image: IMAGES.outdoorHoarding,
  },
];

export const WHY_OUTDOOR = [
  "High Daily Visibility",
  "Continuous Brand Exposure",
  "Trusted Public Locations",
  "Cost Effective Branding",
  "Ideal for Local & National Campaigns",
  "Wide Audience Reach",
];

export const INDUSTRIES = [
  "Retail & Shopping",
  "Healthcare",
  "Education",
  "Real Estate",
  "Hospitality",
  "Automobile",
  "Government Organizations",
  "Banking & Finance",
  "FMCG Brands",
  "Events & Entertainment",
  "Restaurants & Food Chains",
  "Startups & SMEs",
];

export const WHY_CHOOSE = [
  {
    no: "01",
    title: "Strategic Advertising Locations",
    desc: "Premium visibility at carefully selected high-footfall locations.",
  },
  {
    no: "02",
    title: "End-to-End Campaign Management",
    desc: "From planning and creative guidance to execution and support.",
  },
  {
    no: "03",
    title: "Reliable Service",
    desc: "Professional execution with transparent communication and timely delivery.",
  },
  {
    no: "04",
    title: "Experienced Team",
    desc: "A dedicated team focused on delivering impactful advertising solutions.",
  },
];

export const WHY_TWINS = [
  "Established Industry Experience",
  "Railway Station Advertising Specialists",
  "Digital Display Solutions",
  "Outdoor Hoardings",
  "Strategic High-Traffic Locations",
  "Professional Project Execution",
  "Reliable Customer Support",
];

export const RAILWAY_NETWORK = [
  {
    state: "Tamil Nadu",
    stations: [
      "Kanyakumari",
      "Tirunelveli Junction",
      "Virudhunagar Junction",
      "Madurai Junction",
      "Dindigul Junction",
      "Trichy / GOC",
      "Erode Junction",
      "Coimbatore Junction",
      "Chennai – Velachery",
    ],
  },
  {
    state: "Karnataka",
    stations: [
      "Kalaburagi",
      "Wadi",
      "Raichur",
      "Belagavi",
      "Dharwad",
      "Shivamogga",
      "Karwar",
      "Mookambika Road",
      "Udupi",
      "Mangaluru – Airport Road / Jokkette",
    ],
  },
  {
    state: "Telangana",
    stations: ["Hyderabad – Lalaguda"],
  },
  {
    state: "Maharashtra",
    stations: ["Sangli", "Miraj Junction", "Kolhapur"],
  },
];

export const RAILWAY_MEDIA = [
  {
    title: "Hoardings",
    desc: "High impact hoardings at prime locations across railway stations.",
    icon: "Presentation",
    features: [
      { icon: "Eye", label: "High Visibility" },
      { icon: "Users", label: "Wide Reach" },
      { icon: "Target", label: "Maximum Impact" },
    ],
  },
  {
    title: "Non-Lit Platform Boards",
    desc: "Cost-effective and efficient branding on platform boards.",
    icon: "PanelTop",
    features: [
      { icon: "IndianRupee", label: "Budget Friendly" },
      { icon: "Eye", label: "Great Visibility" },
      { icon: "Users", label: "Daily Impressions" },
    ],
  },
  {
    title: "LED Video Walls",
    desc: "Stunning large format LED video walls for dynamic advertising.",
    icon: "LayoutGrid",
    features: [
      { icon: "Sparkles", label: "High Brightness" },
      { icon: "Video", label: "Dynamic Content" },
      { icon: "Users", label: "Captive Audience" },
    ],
  },
  {
    title: "Digital Video Screens",
    desc: "Engaging digital screens to showcase your brand in motion.",
    icon: "MonitorPlay",
    features: [
      { icon: "Monitor", label: "Vibrant Display" },
      { icon: "Video", label: "Video & Motion Ads" },
      { icon: "Clock", label: "Real-time Updates" },
    ],
  },
  {
    title: "Pole Kiosks",
    desc: "Innovative pole kiosks for interactive and impactful branding.",
    icon: "Tablet",
    features: [
      { icon: "Smartphone", label: "Compact & Smart" },
      { icon: "Eye", label: "High Visibility" },
      { icon: "Target", label: "Targeted Reach" },
    ],
  },
  {
    title: "Glow Ball / Illuminated Pillar Boards",
    desc: "Illuminated branding that stands out, day and night.",
    icon: "Lightbulb",
    features: [
      { icon: "Zap", label: "Illuminated 24x7" },
      { icon: "Eye", label: "High Impact" },
      { icon: "Star", label: "Premium Look" },
    ],
  },
  {
    title: "Train Exterior Branding",
    desc: "Full train branding for unmatched visibility on the move.",
    icon: "TrainFront",
    features: [
      { icon: "Eye", label: "Mobile Visibility" },
      { icon: "Users", label: "Massive Reach" },
      { icon: "Megaphone", label: "Powerful Impact" },
    ],
  },
  {
    title: "Train Interior Branding",
    desc: "Branding inside trains for a captive and engaged audience.",
    icon: "Armchair",
    features: [
      { icon: "Users", label: "Captive Audience" },
      { icon: "Eye", label: "High Recall" },
      { icon: "Clock", label: "Longer Exposure" },
    ],
  },
  {
    title: "BMI Scale with Branding Area",
    desc: "Smart BMI machines with branding area for health & visibility.",
    icon: "Gauge",
    features: [
      { icon: "HeartPulse", label: "Health Engagement" },
      { icon: "Monitor", label: "Branding Space" },
      { icon: "BarChart3", label: "Instant BMI Reports" },
    ],
  },
  {
    title: "Station Indoor & Outdoor Advertising",
    desc: "Comprehensive branding solutions inside and outside stations.",
    icon: "Building2",
    features: [
      { icon: "Flag", label: "Wide Coverage" },
      { icon: "Users", label: "High Footfall Areas" },
      { icon: "Target", label: "Maximum Exposure" },
    ],
  },
  {
    title: "Digital Display & Video Advertising",
    desc: "Advanced digital displays for dynamic video advertising.",
    icon: "Tv",
    features: [
      { icon: "Sparkles", label: "4K Quality" },
      { icon: "Video", label: "Dynamic Content" },
      { icon: "TrendingUp", label: "Better Engagement" },
    ],
  },
];

export const CONTACT = {
  addressLines: ["MIG 10, Parijatha", "HUDCO Colony, 3rd Street", "Manipal, Udupi", "Karnataka – 576104", "India"],
  phone: "+91 99805 49123",
  email: "twinsmedia2001@gmail.com",
  website: "www.twinsmediaooh.com",
  hours: [
    { day: "Monday – Saturday", time: "9:00 AM – 6:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
};
